export const CCPA_ANALYTICS = "wonder_ccpa_analytics";
export const ACCESSIBILITY = "wonder_accessibility";
